// import palette from './palette';
export default {
  h6: {
    fontSize: '1.15rem',
  },
};
